import { Link } from "react-router-dom";

const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;

export const RichText = ({ text }) =>
  text.split(TOKEN).filter(Boolean).map((part, i) => {
    if (part.startsWith("**")) return <strong key={i} className="font-semibold text-[var(--ink)]">{part.slice(2, -2)}</strong>;
    const m = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (!m) return part;
    const [, label, href] = m;
    const cls = "text-[var(--saffron-deep)] underline underline-offset-2 hover:text-[var(--ink)]";
    if (href.startsWith("/")) return <Link key={i} to={href} className={cls}>{label}</Link>;
    const ext = href.startsWith("http");
    return <a key={i} href={href} className={cls} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{label}</a>;
  });
